<section class="background-color-nearwhite">
    <div class="container">
        <a class="underlined-link back" da-link [routerLink]="linkAccountCourseList"
            ><span [innerHTML]="'booking.bookingDetails.backToMyCourses' | translate"></span
        ></a>
        <h1 [innerHTML]="'booking.bookingDetails.title' | translate"></h1>
        <p class="large" [innerHTML]="'booking.bookingDetails.intro' | translate"></p>
        <div class="one-columns" *ngIf="bookingDetails$ | async as bookingDetails; else loader">
            <div>
                <h3 [innerHTML]="'booking.bookingDetails.bookingTitle' | translate"></h3>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.courseNumber' | translate"></label>
                    <span>{{ bookingDetails.externalCourseNumber }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.courseTitle' | translate"></label>
                    <span>{{ courseTitle }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.status' | translate"></label>
                    <span *ngIf ="(status$ | async) === 'BOOKED'" [innerHTML]="'courses.status.booked' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'PASSED'" [innerHTML]="'courses.status.passed' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'OFFEN'" [innerHTML]="'courses.status.open' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'WAITINGLIST'" [innerHTML]="'courses.status.waitinglist' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'PROVISIONAL'" [innerHTML]="'courses.status.provisional' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'CANCELLED'" [innerHTML]="'courses.status.cancelled' | translate"></span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.bookingDate' | translate"></label>
                    <span>{{ bookingDetails.bookingDate | date: (dateFormat$ | async) }} </span>
                </div>
            </div>
            <div></div>
        </div>
    </div>
</section>
<section class="background-color-white">
    <div class="container two-columns">
        <div class="" *ngIf="bookingPerson$ | async as bookingPerson">
            <h3 [innerHTML]="'booking.bookingDetails.bookingContact' | translate"></h3>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.salutation' | translate"></label>
                <span>{{ translatedBookingSalutation$ | async }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.userTitle' | translate"></label>
                <span>{{ bookingPerson.title }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.name' | translate"></label>
                <span>{{ bookingPerson.firstName }} {{ bookingPerson.lastName }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.phone' | translate"></label>
                <span>{{ bookingPerson.phone }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.department' | translate"></label>
                <span>{{ bookingPerson.department }}</span>
            </div>
            <br />
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.company' | translate"></label>
                <span>{{ bookingPerson.company }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.street' | translate"></label>
                <span>{{ bookingPerson.address }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.city' | translate"></label>
                <span>{{ bookingPerson.city }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.zipCode' | translate"></label>
                <span>{{ bookingPerson.zipCode }} </span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.country' | translate"></label>
                <span>{{ translatedBookingCountry$ | async }}</span>
            </div>
        </div>
        <ng-container>
            <div class="billing-contact" *ngIf="billingPerson$ | async as billingPerson">
                <h3 [innerHTML]="'booking.bookingDetails.billingContact' | translate"></h3>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.salutation' | translate"></label>
                    <span>{{ translatedBillingSalutation$ | async }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.userTitle' | translate"></label>
                    <span>{{ billingPerson.title }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.name' | translate"></label>
                    <span>{{ billingPerson.firstName }} {{ billingPerson.lastName }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.phone' | translate"></label>
                    <span>{{ billingPerson.phone }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.department' | translate"></label>
                    <span>{{ billingPerson.department }}</span>
                </div>
                <br />
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.company' | translate"></label>
                    <span>{{ billingPerson.company }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.street' | translate"></label>
                    <span>{{ billingPerson.address }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.city' | translate"></label>
                    <span>{{ billingPerson.city }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.zipCode' | translate"></label>
                    <span>{{ billingPerson.zipCode }} </span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.country' | translate"></label>
                    <span>{{ translatedBillingCountry$ | async }}</span>
                </div>
            </div>
        </ng-container>
    </div>
</section>
<section class="background-color-nearwhite">
    <div class="container">
        <p [innerHTML]="'booking.bookingDetails.edit' | translate"></p>
    </div>
</section>
<section class="background-color-white" *ngIf="(bookingDetails$ | async)?.downloads?.length > 0">
    <div class="container">
        <a id="downloads"></a>
        <h3 [innerHTML]="'booking.bookingDetails.courseMaterials' | translate"></h3>
        <div class="downloads-list">
            <div class="download-items">
                <table class="downloads-table">
                    <thead>
                        <tr>
                            <th scope="col">{{ 'booking.bookingDetails.downloadColumnName' | translate }}</th>
                            <th scope="col">{{ 'booking.bookingDetails.downloadColumnValidity' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let download of (bookingDetails$ | async)?.downloads">
                            <td>
                                <label class="checkboxlabel">
                                    <input type="checkbox" [disabled]="!download.downloadable" [checked]="selectedDownloads[download.index] || false" (change)="onDownloadCheckboxChange(download.index, $event.target.checked)">
                                    <span class="checkboxlabelvalue" [ngClass]="{ disabled: !download.downloadable }">
                                        <span *ngIf="!download.url">{{ download.materialName }}</span>
                                        <a *ngIf="download.url" [href]="download.url" da-link>{{ download.materialName }}</a>
                                    </span>
                                </label>
                            </td>
                            <td class="validity-date">
                                <span *ngIf="download.downloadableFrom">
                                    {{ 'booking.bookingDetails.downloadFrom' | translate }} 
                                    {{ download.downloadableFrom | date: (dateFormat$ | async) }} 
                                </span>         

                                <span *ngIf="download.downloadableTo">
                                    {{ 'booking.bookingDetails.downloadTo' | translate }} 
                                    {{ download.downloadableTo | date: (dateFormat$ | async) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="download-actions-row">                
                <div *ngIf="showDownloadErrorMessage$ | async" class="error-message">
                    {{ 'booking.bookingDetails.downloadError' | translate }}
                </div>
                <label class="checkboxlabel">
                    <input type="checkbox" [checked]="selectAllDownloads" (change)="onSelectAllDownloadsChange($event.target.checked)">
                    <span class="checkboxlabelvalue">{{ 'booking.bookingDetails.selectAll' | translate }}</span>
                </label>
                <button class="button primary" [disabled]="!(activeDownloadButton$ | async)" (click)="onDownloadSelected()">{{ 'booking.bookingDetails.downloadSelected' | translate }}</button>
            </div>
        </div>
    </div>
</section>
<ng-template #loader>
    <section>
        <div id="loader-screen" class="drg-loading-container">
            <i class="loading-icon"></i>
            <i class="loader-shadow"></i>
        </div>
    </section>
</ng-template>
